var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-layout" }, [
    _c("div", { ref: "dataRef" }, [
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            { staticClass: "body" },
            _vm._l(_vm.dataList, function(dataItem, index) {
              return _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "text-align": "left"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(dataItem.fullName))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "text-align": "left"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(dataItem.attrGroupName))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "text-align": "left"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(dataItem.attrItemName))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "text-align": "left"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(dataItem.unPassReason))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "text-align": "left"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(dataItem.handleMode))])]
                )
              ])
            })
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row", staticStyle: { height: "40px" } }, [
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("机构全称")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("属性分组")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("字段名称")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("未通过原因")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("处理方式")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4579fc0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4579fc0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/OrgStateChangCheckDlg.vue
// module id = 2259
// module chunks = 0